// @flow
import type JourneyType from "../../records/Journey"

export default (journey: JourneyType, language: string, nationality: string) =>
  nationality === "ru" &&
  language === "ru" &&
  journey.getCountries().some(country => country !== "ru")
